import { useEffect } from 'react';

/**
 * Hook to ensure nav labels show full text on hover via native title tooltip
 * This adds title attributes to navigation items for better UX
 */
export const useNavigationTooltips = (navigationSignature: string) => {
  useEffect(() => {
    const labelNodes = document.querySelectorAll(
      '.MuiDrawer-root .MuiListItemButton-root .MuiTypography-root'
    );
    labelNodes.forEach(node => {
      const el = node as HTMLElement;
      el.setAttribute('title', el.textContent ?? '');
    });
  }, [navigationSignature]);
};
